export const SET_DISCOVERY_DATA = 'SET_DISCOVERY_DATA';
export const UPDATE_DISCOVERY_DATA = 'UPDATE_DISCOVERY_DATA';
export const SET_WHOLE_DISCOVERY = 'SET_WHOLE_DISCOVERY';
